import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../../Services/api';
import globals from '../../../../Globals.json';

const handleNewKeysFamily = (products: any, type: number) => {
  return products?.map((product: any) => ({
    ...product,
    sale_price: product?.sale_price,
    ItemKeyId: product?.id_pdv?.toString(),
    ItemDescription: product.sale_name,
    Description: product.description,
    Price: product?.sale_price,
    Type: type,
  }));
};

export const createProductAsync = createAsyncThunk(
  'create/product',
  async (data: any, thunkAPI) => {
    try {
      const res = await api.post(globals.api.products + '/minified', data);

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const editeProductAsync = createAsyncThunk(
  'put/product',
  async (data: any, thunkAPI) => {
    try {
      const res = await api.put(globals.api.products + `/${data?.uuid}`, data);

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createConfigPizzaAsync = createAsyncThunk(
  'create/configPizza',
  async (data: any, thunkAPI) => {
    try {
      const res = await api.post(globals.api.configPizza, data);

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const putConfigPizzaAsync = createAsyncThunk(
  'put/configPizza',
  async (dataEdite: any, thunkAPI) => {
    try {
      const res = await api.put(
        globals.api.configPizza + `/${dataEdite?.uuid}`,
        dataEdite
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getFamilyProductAsync = createAsyncThunk(
  'get/family',
  async (data: { storeId: number; categoryId?: number }, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.products +
        `/minified?paginate=false&store_id=${data?.storeId}&filter[id_pdv_category]=${data?.categoryId}&filter[is_active]=true&id_number=10`
      );

      return handleNewKeysFamily(res.data.data, 1);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getEdgesProductAsync = createAsyncThunk(
  'get/edges',
  async (data: { storeId: number; categoryId?: number }, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.products +
        `/minified?paginate=false&store_id=${data?.storeId}&filter[id_pdv_category]=${data?.categoryId}&filter[is_active]=true&id_number=11`
      );


      return handleNewKeysFamily(res.data.data, 2);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getExtrasProductAsync = createAsyncThunk(
  'get/extras',
  async (data: { storeId: number; categoryId?: number }, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.products +
        `/minified?paginate=false&store_id=${data?.storeId}&filter[id_pdv_category]=${data?.categoryId}&filter[is_active]=true&id_number=12`
      );

      return handleNewKeysFamily(res.data.data, 3);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getCommentsProductAsync = createAsyncThunk(
  'get/comments',
  async (data: { storeId: number; categoryId?: number }, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.products +
        `/minified?paginate=false&store_id=${data?.storeId}&filter[id_pdv_category]=${data?.categoryId}&filter[is_active]=true&id_number=13`
      );
      return handleNewKeysFamily(res.data.data, 4);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getPizzasAsync = createAsyncThunk(
  'get/pizzas',
  async (path: { storeId: number; page?: number }, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.products +
        `?paginate=false&store_id=${path.storeId}&filter[product_type_id]=6&filter[is_active]=true&id_number=14`
      );
      //`?page=${path.page}&store_id=${path.storeId}&filter[product_type_id]=7`);
      return res.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductAsync = createAsyncThunk(
  'get/products',
  async (
    path: {
      storeId: number;
      page: number;
      isComplement?: boolean;
      productSearch?: string;
    },
    thunkAPI
  ) => {
    try {
      const baseUrl = `${globals.api.products}/minified?page=${path.page}&store_id=${path.storeId}&filter[is_active]=true&id_number=15`;
      const productNameFilter =
        path?.productSearch && path?.productSearch?.length > 2
          ? `&filter[product_name]=${encodeURIComponent(path?.productSearch)}`
          : '';

      if (!path?.isComplement) {
        const res = await api.get(baseUrl + productNameFilter);
        return res.data;
      } else {
        const [res1, res2] = await Promise.all([
          api.get(`${baseUrl}&filter[product_type_id]=3&filter[is_active]=1${productNameFilter}&id_number=16`),
          api.get(`${baseUrl}&filter[product_type_id]=8&filter[is_active]=1${productNameFilter}&id_number=17`),
        ]);

        // Combinar os dados das duas respostas
        const combinedData = {
          ...res1.data,
          data: [...(res1.data?.data || []), ...(res2.data?.data || [])],
        };

        return combinedData;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getCategoriesProductAsync = createAsyncThunk(
  'get/categories',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.categoriesCompleted + `/minified?paginate=false&store_id=${storeId}&filter[is_active]=true`
      );

      // Corrigido: filtra apenas categorias que têm children antes de fazer flatMap
      const categoriesChildren = res.data.data
        ?.filter((category: any) => category.relationships?.children)
        .flatMap((category: any) => category.relationships.children) ?? [];
      
      const allCategories: any = [...res.data.data, ...categoriesChildren];
      return allCategories;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getTypesProductAsync = createAsyncThunk(
  'get/product-types',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.productTypes + `?paginate=false&store_id=${storeId}&filter[is_active]=true`
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductsWithFiltersAsync = createAsyncThunk(
  'get/products-with-filters',
  async (
    params: {
      storeId: number;
      page: number;
      filter?: string;
      paramSorted?: string;
    },
    thunkAPI
  ) => {
    const { filter, page, storeId, paramSorted } = params;

    const uri =
      filter !== undefined
        ? `?${filter}&page=${page}&per_page=${15}&append=stock_qty&store_id=${storeId}&filter[is_active]=true&${paramSorted}`
        : `?page=${page}&per_page=${15}&append=stock_qty&sort=created_at&store_id=${storeId}&filter[is_active]=true${paramSorted ? `&${paramSorted}` : ''
        }`;

    try {
      const res = await api.get(globals.api.products + '/minified' + uri + '&id_number=18');
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getVendorAsync = createAsyncThunk(
  'get/vendor',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.people + `/type/vendor?paginate=false&store_id=${storeId}`
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getLastCodeAsync = createAsyncThunk(
  'get/last-code',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.products + `/minified?store_id=${storeId}&sort=-id_pdv&filter[is_active]=true&id_number=19`
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductPurposeAsync = createAsyncThunk(
  'get/product-purpose',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.purposes + `?paginate=false&store_id=${storeId}&filter[is_active]=true`
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductMeasureAsync = createAsyncThunk(
  'get/product-measure',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.measure + `?paginate=false&store_id=${storeId}&filter[is_active]=true`
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductLocalStockAsync = createAsyncThunk(
  'get/product-local-stock',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.stocks + `?paginate=false&store_id=${storeId}&filter[is_active]=true`
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductTaxProfileAsync = createAsyncThunk(
  'get/product-tax-profile',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.taxProfile + `?paginate=false&store_id=${storeId}&filter[is_active]=true`
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductStateAsync = createAsyncThunk(
  'get/product-state',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.states + `?paginate=false&store_id=${storeId}&filter[is_active]=true`
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductInvoiceTypesAsync = createAsyncThunk(
  'get/product-invoice-types',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.taxes + `/invoices-types?paginate=false&filter[is_active]=true`
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductCstOriginsAsync = createAsyncThunk(
  'get/product-cts-origins',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.taxes + `/cst-origins?paginate=false&filter[is_active]=true`
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductNcmAsync = createAsyncThunk(
  'get/product-ncms',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(globals.api.taxes + `/ncms?paginate=false&filter[is_active]=true`);

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductCestsAsync = createAsyncThunk(
  'get/product-cests',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(globals.api.taxes + `/cests?paginate=false&filter[is_active]=true`);

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductCfopAsync = createAsyncThunk(
  'get/product-cfops',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(globals.api.taxes + `/cfop?paginate=false&filter[is_active]=true`);

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductIcmsCustomerTypesAsync = createAsyncThunk(
  'get/product-icms-customer-types',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.taxes + `/icms-customer-types?paginate=false&filter[is_active]=true`
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductCstsAsync = createAsyncThunk(
  'get/product-csts',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(globals.api.taxes + `/csts?paginate=false&filter[is_active]=true`);

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getProductCstReasonsAsync = createAsyncThunk(
  'get/cst-reasons',
  async (storeId: number, thunkAPI) => {
    try {
      const res = await api.get(
        globals.api.taxes + `/cst-reasons?paginate=false&filter[is_active]=true`
      );

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getConfigPizzaAsync = createAsyncThunk(
  'get/configPizza',
  async (uuid: any, thunkAPI) => {
    try {
      const res = await api.get(globals.api.configPizza + `/${uuid}?filter[is_active]=true`);

      return res.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const getAllProductsAsync = createAsyncThunk(
  'get/all-products',
  async (path: { storeId: number; isComplement?: boolean }, thunkAPI) => {
    console.log('🚀🚀🚀 getAllProductsAsync EXECUTOU! path:', path);
    try {
      const baseUrl = `${globals.api.products}/minified?paginate=false&store_id=${path.storeId}&filter[is_active]=true`;
      console.log('🔗 URL gerada:', baseUrl);

      if (!path?.isComplement) {
        const res = await api.get(baseUrl);
        console.log('✅ Resposta:', res.data);
        console.log('📊 Total itens:', res.data?.data?.length ?? res.data?.length);
        return res.data.data;
      } else {
        const [res1, res2] = await Promise.all([
          api.get(`${baseUrl}&filter[product_type_id]=3`),
          api.get(`${baseUrl}&filter[product_type_id]=8`),
        ]);
        const combined = [...(res1.data?.data || []), ...(res2.data?.data || [])];
        console.log('📊 Total combinado:', combined.length);
        return combined;
      }
    } catch (error) {
      console.error('❌ getAllProductsAsync ERRO:', error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);